import AppLogo from '../shared/AppLogo.jsx';
import { getDomainBranding } from '../../tenant/tenantConfig.js';

export default function NoTenant() {
  const branding = getDomainBranding();
  const domain = 'tryggr.dk';

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--bg)',
        fontFamily: 'var(--font-body)',
      }}
    >
      <div style={{ textAlign: 'center', padding: '0 24px', maxWidth: 480 }}>
        <AppLogo size={64} borderRadius={16} style={{ margin: '0 auto 24px' }} />
        <div
          className="display"
          style={{ fontSize: 32, fontWeight: 700, color: 'var(--fg)', marginBottom: 12 }}
        >
          {branding.name}
        </div>
        <div style={{ fontSize: 15, color: 'var(--fg2)', lineHeight: 1.6, marginBottom: 32 }}>
          Compliance Management Platform for modern security teams.
        </div>
        <div
          style={{
            padding: '16px 20px',
            borderRadius: 12,
            background: 'var(--bg2)',
            border: '1px solid var(--border)',
            fontSize: 12,
            color: 'var(--fg3)',
            fontFamily: 'var(--font-mono)',
            lineHeight: 1.8,
          }}
        >
          Access your workspace at
          <br />
          <span style={{ color: 'var(--accent)', fontWeight: 600 }}>yourcompany.{domain}</span>
        </div>
        <div style={{ marginTop: 16, fontSize: 11, color: 'var(--fg3)' }}>
          Don't have an account? Contact your {branding.name} administrator.
        </div>
      </div>
    </div>
  );
}
